import React from 'react';
import styled from 'styled-components';

export function CategoryButton({ text }) {
  return (
    <Button tabIndex={0}>
      {text}
    </Button>
  );
}

const Button = styled.button`
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  width: 161px;
  padding: 20px;
  border: none;
  color: white;
  font-family: inherit;
  font-size: 12px;
  cursor: pointer;
  
  &:hover {
    opacity: 0.9;
  }
  
  &:focus {
    outline: 2px solid white;
    outline-offset: 2px;
  }
`; 